// extracted by mini-css-extract-plugin
export var contentBody = "_6x-9";
export var headerImage = "_6x-2";
export var imageButton = "_6x-7";
export var imageButtonIcon = "_6x-8";
export var imageHeader = "_6x-4";
export var imageHeaderText = "_6x-5";
export var imageOverlay = "_6x-3";
export var imageTitle = "_6x-6";
export var imageWrapper = "_6x-1";
export var taskList = "_6x-a";
export var widget = "_6x-0";